import * as Sentry from "@sentry/react";

function init() {
  Sentry.init({
    dsn: "https://36d454e81b664ebaa4c50ce080f3f9d7@o264925.ingest.sentry.io/5319693",
  });
}

function log(error) {
  Sentry.captureException(error);
}

const logger = { init, log };

export default logger;
